import { OrderCalculation, OrderLoading, OrderUnloading } from "../../../../api/types/order"
import { regex } from "../../../../common/regex"
import { FormErrors } from "../../../FieldError"

export const validateIn = (value: string | null): FormErrors<OrderCalculation> => {
  let errors: FormErrors<OrderCalculation> = {}

  if (value) {
    if (regex.IC.test(value)) {
      errors.unloadingIn = ""
    } else {
      errors.unloadingIn = "IČ není ve správném formátu. Zadejte prosím 8 číslic."
    }
  } else {
    errors.unloadingIn = ""
  }

  return errors
}

export const validateVatId = (value: string | null): FormErrors<OrderCalculation> => {
  let errors: FormErrors<OrderCalculation> = {}

  if (value) {
    if (regex.DIC.test(value)) {
      errors.unloadingVatId = ""
    } else {
      errors.unloadingVatId = "DIČ není ve správném formátu."
    }
  } else {
    errors.unloadingVatId = ""
  }

  return errors
}

export const validateEmail = (value: string | null): FormErrors<OrderLoading | OrderUnloading> => {
  let errors: FormErrors<OrderLoading | OrderUnloading> = {}

  if (value) {
    if (regex.email.test(value)) {
      errors.email = ""
    } else {
      errors.email = "E-mail není ve správném formátu."
    }
  } else {
    errors.email = ""
  }

  return errors
}

export const validateTimeRange = (value: string): FormErrors<OrderCalculation> => {
  let errors: FormErrors<OrderCalculation> = {}

  if (value) {
    let splits = value.split("-")
    const fromStr = splits[0]
    const toStr = splits[1]

    splits = fromStr.split(":")
    const fromStrHours = splits[0]
    const fromStrMinutes = splits[1]

    splits = toStr.split(":")
    const toStrHours = splits[0]
    const toStrMinutes = splits[1]

    let from = parseInt(fromStrHours)

    if (fromStrMinutes === "30") {
      from += 0.5
    }

    let to = parseInt(toStrHours)

    if (toStrMinutes === "30") {
      to += 0.5
    }

    if (from > to) {
      errors.unloadingTime = "Hodnota 'od' nesmí být později než hodnota 'do'."
    } else if (from === to) {
      errors.unloadingTime = "Minimální interval je 30 minut."
    } else if (to - from > 2) {
      errors.unloadingTime = "Maximální interval jsou 2 hodiny."
    } else {
      errors.unloadingTime = ""
    }
  }

  return errors
}
